function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 41,
  cy: 41,
  rx: 40,
  ry: 40,
  fill: "#f8cecc",
  stroke: "#000000",
  strokeWidth: 2,
  pointerEvents: "all"
});

var _ref4 = /*#__PURE__*/React.createElement("text", {
  x: 41,
  y: 45,
  fill: "#000000",
  fontFamily: "Helvetica",
  fontSize: "12px",
  textAnchor: "middle"
}, "Calista");

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 201,
  cy: 41,
  rx: 40,
  ry: 40,
  fill: "#f8cecc",
  stroke: "#b85450",
  pointerEvents: "all"
});

var _ref6 = /*#__PURE__*/React.createElement("text", {
  x: 201,
  y: 45,
  fill: "#000000",
  fontFamily: "Helvetica",
  fontSize: "12px",
  textAnchor: "middle"
}, "Rosie");

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 121,
  cy: 161,
  rx: 40,
  ry: 40,
  fill: "#dae8fc",
  stroke: "#6c8ebf",
  pointerEvents: "all"
});

var _ref8 = /*#__PURE__*/React.createElement("text", {
  x: 121,
  y: 165,
  fill: "#000000",
  fontFamily: "Helvetica",
  fontSize: "12px",
  textAnchor: "middle"
}, "Bennie");

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M 69.28 69.28 L 98.31 120.56",
  fill: "none",
  stroke: "#000000",
  strokeMiterlimit: 10,
  pointerEvents: "stroke"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M 100.89 125.13 L 94.4 120.77 L 98.31 120.56 L 100.49 117.32 Z",
  fill: "#000000",
  stroke: "#000000",
  strokeMiterlimit: 10,
  pointerEvents: "all"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M 178.9 74.34 L 146.73 122.43",
  fill: "none",
  stroke: "#000000",
  strokeMiterlimit: 10,
  pointerEvents: "stroke"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M 143.81 126.79 L 144.79 119.02 L 146.73 122.43 L 150.61 122.92 Z",
  fill: "#000000",
  stroke: "#000000",
  strokeMiterlimit: 10,
  pointerEvents: "all"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M 81 41 L 154.63 41",
  fill: "none",
  stroke: "#000000",
  strokeMiterlimit: 10,
  pointerEvents: "stroke"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M 159.88 41 L 152.88 44.5 L 154.63 41 L 152.88 37.5 Z",
  fill: "#000000",
  stroke: "#000000",
  strokeMiterlimit: 10,
  pointerEvents: "all"
});

var _ref15 = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
  requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
}), /*#__PURE__*/React.createElement("a", {
  transform: "translate(0,-5)",
  xlinkHref: "https://desk.draw.io/support/solutions/articles/16000042487",
  target: "_blank"
}, /*#__PURE__*/React.createElement("text", {
  textAnchor: "middle",
  fontSize: "10px",
  x: "50%",
  y: "100%"
}, "Viewer does not support full SVG 1.1")));

var SvgCompleteTournament = function SvgCompleteTournament(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "242px",
    height: "202px",
    viewBox: "-0.5 -0.5 242 202",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2020-08-07T01:40:36.665Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_5) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/84.0.4147.105 Safari/537.36\" etag=\"qOyX0w2xQlz4m5dH6uRl\" version=\"13.6.0\" type=\"device\"><diagram id=\"Ra3Fi83U9BzJdPZ0KHpK\" name=\"Page-1\">1VfbcpswEP0aP8ajC2D5MXZuM53MZOrMNH1UYDGaysgVcsD++gojMGAnaRKnTp/Qnl1Wqz0HSQzodFFca75MblUEckBQVAzoxYAQ7JHAPkpkXSGjEa6AuRaRC9oBM7EBByKHrkQEWSfQKCWNWHbBUKUphKaDca1V3g2LlezOuuRz2ANmIZf76A8RmaRCmY92+A2IeVLPjJHzLHgd7IAs4ZHKWxC9HNCpVspUo0UxBVk2r+5L9d7VM96mMA2p+ZsXbjfTnN1cfUvu87v7eLJ52ODrM5flicuVW/CABNLmm8TKprVVm7VrRfB7pWrHWbYl6twG4GBZ7Jx2NC+fUy5FZnidzFZV5au8riFNamIrtYRaY5InwsBsycPSk1tNWSwxC2ktbIc8W1Ysx6KAqKxGSDlVUultIhqzEMLQ4pnR6ldDGWkmbferXjxoA0ULcv27BrUAo9c2xHkJc1w6MePA2XlLGg5KWqqoMe7EOG8y7/iyA0fZG+gjn0Tfd5UJODV5Lc8j8z37yR2FRM/7YiTSTyJxAml6AhYjDiw+yGIQMniMj8MiDbosNvScisXgAIv9FqfReXkkWSuUPMtE2O0sFMI8tMY/W+OLct2oNtbOeLaRmVrpEF7f+A3XczCvixOizjG5T0ur7f6BtteYBsmNeOoeroe4cDPcKbH9BGrWUY912qOzWrd7q30Y9hP53USU9BJVjdlLtJVGs+z3q4V9XC32eNWmjkhVCjV2JcpaKrGkkbPwh9RC/k+1YDK0F1APBWyE8ZiMRz3xHHa/WUsjNvQCqyh/hBBmGNGutCgbjv2Ajn1GPIQ88k+FNj6G0NpXqec2KjT0X9yqjiVF/LUkRrpkE/TODal/K9lL9G6dWHP3k1GF737V6OUf</diagram></mxfile>",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 41,
      marginLeft: 2
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, "Calista"))))), _ref4)), _ref5, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 41,
      marginLeft: 162
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, "Rosie"))))), _ref6)), _ref7, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 161,
      marginLeft: 82
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "#000000",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, "Bennie"))))), _ref8)), _ref9, _ref10, _ref11, _ref12, _ref13, _ref14), _ref15);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompleteTournament, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/complete-tournament.879eec74.svg";
export { ForwardRef as ReactComponent };